import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import axios from "axios";
import NoticePlaceholder from "./placeholders/NoticePlaceholder";
import { getPostDate } from "../../../utils/date";
import { useSelector } from "react-redux";

export const LeftPart = () => {
  const lang = useSelector((state) => state.mainSlice.lang);
  const [notice, setNotice] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const params = useParams();

  useEffect(() => {
    setIsLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/notices/detail/${params.slug}/`
      )
      .then((res) => {
        setNotice(res.data);
      })
      .then(() => {
        setIsLoading(false);
      });
  }, [params]);

  return (
    <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
      {isLoading === true ? (
        <NoticePlaceholder />
      ) : (
        <div>
          <h4 className="fw-bold">
            {lang === "en"
              ? notice.name_en
              : lang === "ru"
              ? notice.name_ru
              : notice.name_tm}
          </h4>
          <div className="d-flex align-items-center mb-3">
            {getPostDate(notice.pub_date)} &nbsp;&nbsp; <Icon.Eye />{" "}
            {notice.views}
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html:
                lang === "en"
                  ? notice.content_en
                  : lang === "ru"
                  ? notice.content_ru
                  : notice.content_tm,
            }}
          ></div>
        </div>
      )}
    </div>
  );
};
